import { TPartnerType } from '@/modules/partner/model/partnerType';
import { TTaxProfile } from '@/modules/taxProfile/model/taxProfile';

type PayoutsForm = {
  partnerType: TPartnerType;
  companyName: string;
  companyAddress: string;
  companyRegNumber: string;
  vatRegNo: string;
  inn: string;
  kpp: string;

  // US onboarding fields
  ssn?: string;
  dbaName?: string;
  zipCode?: string;
  city?: string;
  licenseNumber?: string;
  ein?: string;

  // GB onboarding fields
  taxProfile: TTaxProfile | null | undefined;
  vatAgreementAccepted: boolean;
  hasPhoLicense?: 'yes' | 'no' | null;
};

const mapPhoLicenseToApi = (value: PayoutsForm['hasPhoLicense']): boolean | undefined => {
  if (value === 'yes') {
    return true;
  }

  if (value === 'no') {
    return false;
  }

  return;
};

const mapPhoLicenseToForm = (value: boolean | null): PayoutsForm['hasPhoLicense'] => {
  if (value === true) {
    return 'yes';
  }

  if (value === false) {
    return 'no';
  }

  return null;
};

export type { PayoutsForm };
export { mapPhoLicenseToApi, mapPhoLicenseToForm };
